var _circle, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "#FFE6E6",
    stroke: "#E95420"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.88916 8.94434C9.1653 8.94434 9.38916 9.16819 9.38916 9.44434V12.7777C9.38916 13.0538 9.1653 13.2777 8.88916 13.2777C8.61302 13.2777 8.38916 13.0538 8.38916 12.7777V9.44434C8.38916 9.16819 8.61302 8.94434 8.88916 8.94434Z",
    fill: "#E95420"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1113 8.94434C11.3875 8.94434 11.6113 9.16819 11.6113 9.44434V12.7777C11.6113 13.0538 11.3875 13.2777 11.1113 13.2777C10.8352 13.2777 10.6113 13.0538 10.6113 12.7777V9.44434C10.6113 9.16819 10.8352 8.94434 11.1113 8.94434Z",
    fill: "#E95420"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.05566 7.22217C5.05566 6.94603 5.27952 6.72217 5.55566 6.72217H14.4446C14.7207 6.72217 14.9446 6.94603 14.9446 7.22217C14.9446 7.49831 14.7207 7.72217 14.4446 7.72217H5.55566C5.27952 7.72217 5.05566 7.49831 5.05566 7.22217Z",
    fill: "#E95420"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16699 7.22217C6.16699 6.94603 6.39085 6.72217 6.66699 6.72217H13.3337C13.6098 6.72217 13.8337 6.94603 13.8337 7.22217V13.3333C13.8337 14.5299 12.8636 15.4999 11.667 15.4999H8.33366C7.13705 15.4999 6.16699 14.5299 6.16699 13.3333V7.22217ZM7.16699 7.72217V13.3333C7.16699 13.9776 7.68932 14.4999 8.33366 14.4999H11.667C12.3113 14.4999 12.8337 13.9776 12.8337 13.3333V7.72217H7.16699Z",
    fill: "#E95420"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.44461 5.5C9.1071 5.5 8.8335 5.7736 8.8335 6.11111V6.72222H11.1668V6.11111C11.1668 5.7736 10.8932 5.5 10.5557 5.5H9.44461ZM7.8335 6.11111C7.8335 5.22132 8.55481 4.5 9.44461 4.5H10.5557C11.4455 4.5 12.1668 5.22132 12.1668 6.11111V7.22222C12.1668 7.49836 11.943 7.72222 11.6668 7.72222H8.3335C8.05735 7.72222 7.8335 7.49836 7.8335 7.22222V6.11111Z",
    fill: "#E95420"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.f4933dd75e34cbfde0250503ae0339ce.svg";
export { ForwardRef as ReactComponent };